import React from 'react'
import './App.css'
import { Header, About, Menu, Gallery, Footer } from './containers'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AboutPage, MenuPage, GalleryPage, ContactsPage } from './pages'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <div>
              <Header />
              <About />
              <Menu />
              <Gallery />
              <Footer />
            </div>
          }
        />
        <Route
          path="/about"
          element={<AboutPage />}
        />
        <Route
          path="/menu"
          element={<MenuPage />}
        />

        <Route
          path="/gallery"
          element={<GalleryPage />}
        />

        <Route
          path="/contact-us"
          element={<ContactsPage />}
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App
